import { FC, useEffect, useState } from 'react';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import { useNavigate } from 'react-router';
import { NetworkType } from './types';
import NodeCard from './NodeCard';
import { breadcrumbPath } from '../../../utils/helpers';
import {
  getAllNodesData, getNetworkDetailData,
} from './api';
import Loader from '../../common/loader';

interface NetworkDetailsProps {
  id: string;
}

const logoPath = (val: string) => {
  if (val.includes(' ')) {
    // eslint-disable-next-line prefer-destructuring, no-param-reassign
    val = val.replace(/\s/g, '');
  }
  switch (val.toLowerCase()) {
    case 'corda': return 'images/protocols/logos/corda_logo.svg';
    case 'r3': return 'images/protocols/logos/corda_logo.svg';
    case 'ethereum': return 'images/protocols/logos/ethereum_logo.svg';
    case 'credit': return 'images/protocols/logos/credits.png';
    case 'fabric': return 'images/protocols/logos/Hyperledger-Fabric_logo.svg';
    case 'sawtooth': return 'images/protocols/logos/sawtooth_logo.svg';
    case 'fluree': return 'images/protocols/logos/fluree_logo.svg';
    case 'phaeton': return 'images/protocols/logos/phaeton_logo.svg';
    case 'polygon': return 'images/protocols/logos/Polygonpos_logo.svg';
    case 'binance': return 'images/protocols/logos/binance_logo.svg';
    case 'tron': return 'images/protocols/logos/tron_logo.svg';
    case 'avalanche': return 'images/protocols/logos/avalanche_logo.svg';
    case 'axia': return 'images/protocols/logos/axia_logo.svg';
    case 'fantom': return 'images/protocols/logos/Fantom_logo.svg';
    case 'dcomm': return 'images/protocols/logos/dcommdark_logo.svg';
    case 'polkadot': return 'images/protocols/logos/Polkadot_logo.svg';
    case 'okc': return 'images/protocols/logos/okc_logo.svg';
    case 'aptos': return 'images/protocols/logos/Aptos_logo.svg';
    case 'coreum': return 'images/protocols/logos/Coreum_logo.svg';
    case 'shardeum': return 'images/protocols/logos/Shardeum_logo.svg';
    case 'energy-web': return 'images/protocols/logos/Energy_Web_Logo.svg';
    case 'polygon-edge': return 'images/protocols/logos/Polygon-Edge_logo.svg';
    case 'hyperledgerbesu': return 'images/protocols/logos/besu-icon.svg';
    case 'polygoncdkchain': return 'images/protocols/logos/Polygon_cdk.svg';
    case 'parachains': return 'images/protocols/logos/parachains_logo.svg';
    case 'cordaenterprise': return 'images/protocols/logos/corda_logo.svg';
    case 'acala': return 'images/protocols/logos/acala_logo.svg';
    case 'algorand': return 'images/protocols/logos/algorand_logo.svg';
    case 'arbitrum': return 'images/protocols/logos/arbitrum_logo.svg';
    case 'aurora': return 'images/protocols/logos/aurora_logo.svg';
    case 'base': return 'images/protocols/logos/base_logo.svg';
    case 'bitcoin': return 'images/protocols/logos/bitcoin_logo.svg';
    case 'harmony': return 'images/protocols/logos/harmony_logo.svg';
    case 'crossfi': return 'images/protocols/logos/crossfi_logo.png';
    case 'klaytn': return 'images/protocols/logos/klaytn_logo.svg';
    case 'kusama': return 'images/protocols/logos/kusama_logo.svg';
    case 'moonbeam': return 'images/protocols/logos/Moonbeam_logo.svg';
    case 'near': return 'images/protocols/logos/near_logo.svg';
    case 'optimism': return 'images/protocols/logos/optimism_logo.svg';
    case 'tezos': return 'images/protocols/logos/tezos_logo.svg';
    case 'arbitrumnova': return 'images/protocols/logos/arbitrum_nova_logo.svg';
    case 'cardano': return 'images/protocols/logos/cardano_logo.svg';
    case 'celo': return 'images/protocols/logos/celo_logo.svg';
    case 'cosmos': return 'images/protocols/logos/cosmos_logo.svg';
    case 'cronos': return 'images/protocols/logos/cronos_logo.svg';
    case 'flow': return 'images/protocols/logos/flow_logo.svg';
    case 'fuse': return 'images/protocols/logos/fuse_logo.svg';
    case 'gnosischain': return 'images/protocols/logos/gnosischain_logo.svg';
    case 'hedera': return 'images/protocols/logos/hedera_logo.svg';
    case 'lisk': return 'images/protocols/logos/lisk_logo.svg';
    case 'nervos': return 'images/protocols/logos/nervos_logo.svg';
    case 'persistence': return 'images/protocols/logos/persistence_logo.svg';
    case 'solana': return 'images/protocols/logos/solana_logo.svg';
    case 'stacks': return 'images/protocols/logos/stacks_logo.svg';
    case 'ton': return 'images/protocols/logos/ton_logo.svg';
    case 'telos': return 'images/protocols/logos/telos_logo.svg';
    case 'xdc': return 'images/protocols/logos/xdc_logo.svg';
    case 'zkevm': return 'images/protocols/logos/zkevm_logo.svg';
    case 'starknet': return 'images/protocols/logos/starknet_logo.png';
    case 'avalanche-subnets': return 'images/protocols/logos/avalanche_logo.svg';
    case 'bahamut': return 'images/protocols/logos/fastex_logo.svg';
    case 'zksyncera': return 'images/protocols/logos/zksyncera_logo.svg';
    case 'opstack': return 'images/protocols/logos/opstack_logo.svg';
    case 'arbitrumorbit': return 'images/protocols/logos/arbitrum_orbit_logo.svg';
    case 'shido': return 'images/protocols/logos/shido_logo.svg';
    case 'subsquid': return 'images/protocols/logos/subsquid-logo-dark.svg';
    case 'beam': return 'images/protocols/logos/beam_logo.svg';
    case 'beaml1': return 'images/protocols/logos/beam_logo.svg';
    case 'l1': return 'images/protocols/logos/beam_logo.svg';
    default: return '';
  }
};

const NetworkDetails: FC<NetworkDetailsProps> = ({ id }) => {
  const [networkData, setNetworkData] = useState<NetworkType[] | []>([]);
  const [flag, setFlag] = useState<boolean>(false);
  const [page, setPage] = useState<string>('node');
  const [name, setName] = useState<string>('My Network');
  const [nodeId, setNodeId] = useState<string>('');
  const [mangedHosting, setManagedHosting] = useState<boolean>(false);
  const [networkStatus, setNetworkStatus] = useState<string>('');
  const [protocolName, setProtocolName] = useState<string>('');
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [networkType, setNetworkType] = useState<'dedicated' | 'staking'>('dedicated');
  const [customDashboardUrl, setCustomDashboardUrl] = useState(null);
  const [protocolFrontendBaseSubUrl, setProtocolFrontendBaseSubUrl] = useState(null);
  const [edit, toggleEdit] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (networkType === 'staking' && networkData.length !== 0) {
      setNodeId(networkData[0].node_id.toString());
    }
  }, [networkData, networkType]);

  const from = localStorage.getItem('from') || '';
  const paths = breadcrumbPath(from);

  const getNetworkDetail = async () => {
    setShowLoader(true);
    const response: any = await getNetworkDetailData(id);
    // const response: any = await (await axios.get(`http://localhost:3001/network-node/${id}`)).data;
    setShowLoader(false);
    if (response && response.success) {
      setName(response.data.name);
      setNetworkStatus(response.data.status);
      setNetworkType(response.data?.labels?.allowedService);
      setCustomDashboardUrl(response.data.custom_dashboard_url);
      setProtocolName(response.data.protocol_name);
      if (response.data.protocol_frontend_base_suburl && response.data.protocol_frontend_base_suburl != null && response.data.protocol_frontend_base_suburl !== '') {
        setProtocolFrontendBaseSubUrl(`${response.data.protocol_frontend_base_suburl}/network/${id}` as any);
      } else {
        setProtocolFrontendBaseSubUrl(response.data.protocol_frontend_base_suburl);
      }
    }
  };

  const getAllNodes = async () => {
    setShowLoader(true);
    const response: any = await getAllNodesData(id);
    // const response: any = await (await axios.get(`http://localhost:3001/network-node/${id}/nodes`)).data;
    setShowLoader(false);
    if (response && response.success) {
      const networkSetData: NetworkType[] = [];
      for (let i = 0; i < response.data.length; i += 1) {
        const nodeData: NetworkType = {
          node_id: response.data[i].id,
          node_name: response.data[i].name,
          network_id: response.data[i].network_id,
          cloud_id: '-',
          region_id: '-',
          endpoint: '-',
          owned_by: '-',
          owned_by_id: response.data[i].user_id,
          updated_at: '-',
          created_at: response.data[i].created_at,
          redirection_url: '-',
          status: response.data[i].status,
          analyticsUrl: '-',
        };
        networkSetData.push(nodeData);
      }
      setNetworkData(networkSetData);
    } else {
      setNetworkData([]);
    }
  };

  useEffect(() => {
    // Call api for get network details
    getNetworkDetail();
    // Call api for get all nodes list
    getAllNodes();
  }, []);

  // useEffect(() => {
  //   if (customDashboardUrl === null) {
  //     navigate('');
  //   }
  // });
  const setSelected = (num: number) => {
    for (let i = 1; i < 4; i += 1) {
      const spanSelected: HTMLBaseElement | null = document.querySelector(`#span${i}`);
      const liSelected: HTMLBaseElement | null = document.querySelector(`#li${i}`);
      if (i !== num) {
        if (spanSelected && liSelected && spanSelected.classList.contains('active-node')) {
          spanSelected.classList.remove('active-node');
          liSelected.classList.remove('active-item');
        }
      } else if (i === num && spanSelected && !spanSelected.classList.contains('active-node')) {
        spanSelected.classList.add('active-node');
        liSelected?.classList.add('active-item');
      }
    }
  };

  const setView = () => {
    if (page === 'node') {
      return (
              <NodeCard
                  networkData={networkData}
                  setFlag={setFlag}
                  setNodeId={setNodeId}
                  nodeID={nodeId}
                  networkType={networkType}
              />
      );
    }
    return null;
  };

  return (
    <section className="px-5 col-12">
        <div>
            <div className="col-12 mt-4 mx-auto">
                <img src={`/app/${logoPath(protocolName)}`} alt="protocol-logo" width={150} />

                <div className="row align-items-center">
                    <div className="col-lg-6 mt-2 col-xl-6 col-sm-12 col-xs-12">
                        <Breadcrumb
                            prefixLink={paths}
                            className="mt-1"
                            textSize={14}
                            activeLink={name || 'loading'}
                        >
                            <span className="p-1 mx-2 all-color" style={{ fontSize: '13px' }}>
                                {/* {mangedHosting ? ' - Zeeve Managed' : ' - BYOC'} */}
                            </span>
                        </Breadcrumb>
                    </div>
                    <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 button-add">
                        <div className="d-flex justify-content-end mx-5" style={{}}>
                            {networkType === 'staking' && (
                                <button
                                    type="button"
                                    className="ms-2 btn btn-primary"
                                    disabled={networkStatus !== 'ready'}
                                    style={{ borderRadius: '10px' }}
                                    onClick={() => toggleEdit(true)}
                                >
                                    Edit
                                    <i className="fa fa-pen-to-square fs-6 text-white ps-2" aria-hidden />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row justify-content-between ">
                    <div className="col-12 mt-5 h-50">
                        <div className="alert alert-danger mb-1" id="fail" style={{ display: 'none' }} role="alert">
                            User currently doesn&apos;t have permission to perform this action
                        </div>
                        <div
                            className="alert alert-danger mb-1"
                            id="analyticsDiv"
                            style={{ display: 'none' }}
                            role="alert"
                        >
                            Analytics will start after node is in provisioning state
                        </div>
                        <div
                            id="actionSuccess"
                            className="alert alert-success mb-1"
                            style={{ display: 'none' }}
                            role="alert"
                        >
                            Action Performed
                        </div>
                        <div
                            className="alert alert-danger mb-1"
                            id="actionFail"
                            style={{ display: 'none' }}
                            role="alert"
                        >
                            Error performing action
                        </div>
                        <div className="card node-process h-50">
                            <nav className="navbar navbar-expand-lg navbar-light border-bottom">
                                <div className="container-fluid">
                                    <div className="" id="navbarNav">
                                        <ul className="Navbar nav container-equal-space">
                                            <li
                                                id="Li1"
                                                className="nav-item active-item"
                                                aria-hidden
                                                onClick={() => {
                                                  setPage('node');
                                                  setSelected(1);
                                                }}
                                            >
                                                <span id="span1" className="nav-link active-node ">
                                                    Nodes
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                            <table className="table table-responsive">
                                <thead className="text-center">
                                    <tr>
                                        <th scope="col">Node Name</th>
                                        <th scope="col">Cloud Region</th>
                                        <th scope="col">Network Type</th>
                                        <th scope="col">Created At</th>
                                        <th scope="col">Node Status</th>
                                    </tr>
                                </thead>
                                <tbody>{setView()}</tbody>
                            </table>
                        </div>
                    </div>
            </div>
            {
                // @ts-ignore
                showLoader && <Loader style={{ zIndex: 100 }} />
            }
        </div>
        <div id="succ" className="alert alert-success mt-3 mb-5" style={{ display: 'none' }} role="alert">
            Copied
        </div>
    </section>
  );
};

export default NetworkDetails;
